// Whole rupees when exact, otherwise paise — matches what Razorpay charges.
export const formatInr = (n) => {
  const v = Math.round(Number(n || 0) * 100) / 100;
  return `₹${Number.isInteger(v) ? v.toFixed(0) : v.toFixed(2)}`;
};
